import classNames from 'classnames';
import Link from 'next/link';
import { Icon, SkeletonBar, Text } from 'worldover/ui-components';
import { IconNames } from 'worldover/ui-components/src/icon/icons';

const Wrapper = ({
  href,
  onClick,
  className,
  children,
}: {
  href?: string;
  onClick?: () => void;
  className?: string;
  children: React.ReactNode;
}) => {
  if (href) {
    return (
      <Link href={href} className={className}>
        {children}
      </Link>
    );
  }

  if (onClick) {
    return (
      <button onClick={onClick} className={className}>
        {children}
      </button>
    );
  }

  return <div className={className}>{children}</div>;
};

export const LandingPageFreeTierCard = ({
  icon,
  title,
  isLoading,
  preTitle,
  addIcon,
  action,
  href,
  onClick,
}: {
  icon: IconNames;
  title: string;
  isLoading?: boolean;
  preTitle?: string;
  addIcon?: boolean;
  action?: {
    text: string;
    onClick: () => void;
  };
  href?: string;
  onClick?: () => void;
}) => {
  if (isLoading) {
    return <SkeletonBar className='h-[242px] w-full' />;
  }

  return (
    <Wrapper
      href={href}
      onClick={onClick}
      className={classNames(
        'grid grid-rows-[128px_1fr] gap-0',
        'h-[242px] w-full',
        'border-[1px] border-slate-200 rounded-lg',
        'bg-white',
        'shadow-lg',
        'glint-effect',
      )}
    >
      <div
        className='grid place-items-center w-full'
        style={{
          background:
            'linear-gradient(289.69deg, #BFDBFE -6.45%, #FFFFFF 100.86%)',
        }}
      >
        <div className='relative'>
          <Icon name={icon} height={80} width={80} />
          {addIcon && (
            <div className='absolute bottom-[-4px] right-0 grid place-items-center h-[38px] w-[38px] rounded-full bg-blue-100'>
              <Icon
                name='OutlinePlusIcon'
                height={34}
                width={34}
                className='text-blue-700'
              />
            </div>
          )}
        </div>
      </div>
      <div className='flex flex-col justify-between h-full py-[20px] px-[16px]'>
        <div className='flex flex-col gap-[8px]'>
          {preTitle && (
            <Text variant='bodySemi' color='text-slate-400' align='text-left'>
              {preTitle}
            </Text>
          )}
          <Text variant='largeReg' color='text-slate-700' align='text-left'>
            {title}
          </Text>
        </div>
        {action && (
          <div className='flex justify-end w-full'>
            <div className='cursor-pointer' onClick={action.onClick}>
              <Text variant='smallSemi' color='text-blue-600'>
                {action.text}
              </Text>
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  );
};
